import React, { useEffect, useState } from "react"
import ContPlanCardPay from "../ContPlanCardPay"
import Styles from './styles.module.sass'

const ContentMultiplePlans = (props) =>{

    const {
        completePlanData,
        setTextPlan,
        setTotalPlansPay,
        setTotalArrayPlan
    } = props

    useEffect(()=>{
        setTextPlan("0 planes")
    },[])
    
    const [buttonActive, setButtonActive] = useState(false)
    const [planSeleccionad, setPlanSeleccionad] = useState()
    const [planPos, setPlanPos] = useState()
    const [selAll, setSellAll] = useState(false)

    // selecciona todos los planes
    const seleccionarTodos = () => {
        let checkPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPaySup')
        let inicio
        let planPosition = []
        for(inicio = 0; inicio <= (checkPlan.length -1); inicio ++){
            document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input`)[inicio].checked = true
            planPosition.push( inicio )
        }
        setButtonActive(1)
        setPlanPos(planPosition)
        setPlanSeleccionad()
        setSellAll(true)
        changePlan()
        setTextPlan(`${checkPlan.length} planes`)
    };
    
    // deselecciona todos los planes
    const deseleccionarTodos = () => {
        let checkPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPaySup')
        let inicio
        let planPosition = []
        for(inicio = 0; inicio <= (checkPlan.length -1); inicio ++){
            document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input`)[inicio].checked = false
        }
        setButtonActive(0)
        setPlanPos([])
        setPlanSeleccionad([])
        setSellAll(false)
        setTotalPlansPay(0)
        setTextPlan("0 planes")
    };

    // mostrar info por plan
    const [lastslect, setLastSelect] = useState()
    const showInfoPlan = (index) => {
        let pos = index
        setLastSelect(pos)
        if(lastslect != pos){
            if(document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan').length >= 1){
                let i
                for(i = 0; i <= document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan').length; i++ ){
                    document.querySelectorAll('.contentCardsMultiPlan .cardPay.showInfoPlan')[0].classList.remove('showInfoPlan')
                }
            }
            document.querySelectorAll('.contentCardsMultiPlan .cardPay')[pos].classList.add('showInfoPlan')
        }else{
            document.querySelectorAll('.contentCardsMultiPlan .cardPay')[pos].classList.toggle('showInfoPlan')
        }
    }

    // cambiar plan
    const changePlan = () => {
        let checked = document.querySelectorAll(`.contentCardsMultiPlan  .cardPaySup .topPlanName input:checked`)
        let valorMultiPlan = document.querySelectorAll('.contentCardsMultiPlan .cardPay input[type="checkbox"]:checked')

        if( checked?.length === 1){
            setTextPlan(`1 plan`)
        }else if(checked?.length >= 2){
            setTextPlan(`${checked?.length} planes`)
        }else{
            setTextPlan(`0 planes`)
        }
        
        setTimeout(function(){
            if(valorMultiPlan?.length >=1){
                let sel = valorMultiPlan.length
                let cont
                let totalPayArray = []
                let totalPlanArray = []

                for(cont = 0; cont <= (sel -1); cont++){
                    totalPayArray.push(Number( valorMultiPlan[cont].value) )
                    totalPlanArray.push({
                        plan: Number( valorMultiPlan[cont].dataset.plan),
                        sequence: Number( valorMultiPlan[cont].dataset.sequence),
                        amount: Number( valorMultiPlan[cont].value) 
                    })
                }
                setTotalPlansPay( sumarTotal(totalPayArray) )
                
                setTotalArrayPlan( totalPlanArray.filter(val => val.amount != 0 ) )
                // console.log(':::: ',totalPlanArray.filter(val => val.amount != 0 ))
            }
            else{
                setTotalPlansPay(0)
                setTotalArrayPlan([])
            }
        },100)
    }

    const sumarTotal = (totalPayArray) => {
        let totalPagar
        totalPagar = totalPayArray.reduce((a,b) => a+b, 0)

        return totalPagar
    }

    return(
        <>
            <div className={Styles?.linkSeleccionarTodos}>
                {selAll
                    ? <p className={Styles?.active} onClick={deseleccionarTodos}>Deseleccionar todos</p>
                    : <p className={Styles?.inactive} onClick={seleccionarTodos}>Seleccionar todos</p>
                }
            </div>

            <form className={`${Styles?.contentCardsMultiPlan} contentCardsMultiPlan`} onChange={changePlan}>
                {completePlanData && completePlanData.map((payPlans, ind) =>
                        <ContPlanCardPay
                            key={ind}
                            ind={ind}
                            plan_name={payPlans.plan_name}
                            monthly_payment={payPlans.monthly_payment}
                            balance_cutting={payPlans.balance_cutting}
                            new_balance_cutting={payPlans.new_balance_cutting}
                            minimum_payment={payPlans.minimum_payment}
                            sequence={payPlans.sequence}
                            pay_plan={payPlans.pay_plan}
                            showInfoPlan={showInfoPlan}
                            allChecked={selAll}
                        />
                    )
                }
            </form>
        </>
    )
}

export default ContentMultiplePlans;